"use strict";
exports.__esModule = true;
exports.chart_color_cyan_100 = {
  "name": "--pf-v5-chart-color-cyan-100",
  "value": "#a2d9d9",
  "var": "var(--pf-v5-chart-color-cyan-100, #a2d9d9)"
};
exports["default"] = exports.chart_color_cyan_100;